import _ from 'lodash';
import queryString from 'query-string';
import { useSelector } from 'react-redux';
import { ALL_SELECT_OPTION, BFF_HOST } from '../../constants/settings.constants';
import { useDossiersAdvancedSearch } from '../../hooks/dossiers/useDossiersAdvancedSearch.hook';
import { DOSSIERS_ADVANCED_SEARCH_RESOURCE } from '../../resources/advanced-search/dossiers.advanced.search.resource';
import { DOSSIERS_RESOURCE } from '../../resources/dossiers.resource';
import { advancedSearchFiltersSelector } from '../../selectors/advanced.search.selectors';
import { currentUserSelector } from '../../selectors/auth.selectors';
import { tableDataSelector } from '../../selectors/resources.selectors';
import permissionsService from '../../services/permissions/permissions.service';
import { getToken } from '../../services/session.storage';
import AdvancedSearch from '../core/advanced-search/AdvancedSearch';
import DossiersTable from './DossiersTable';

const Dossiers = () => {
  const user = useSelector(currentUserSelector);
  const title = permissionsService.canSeeAllDossiers(user) ? 'Dossiers' : 'Mijn dossiers';
  const advancedSearch = useDossiersAdvancedSearch();
  const filters = useSelector((state) =>
    advancedSearchFiltersSelector(state, { resource: DOSSIERS_ADVANCED_SEARCH_RESOURCE })
  );
  const { config } = useSelector((state) => tableDataSelector(state, { resource: DOSSIERS_RESOURCE }));

  const handleCsvExport = () => {
    const searchQuery = queryString.stringify(
      _.mapValues({ ...config, ...filters }, (value) =>
        value === ALL_SELECT_OPTION.value || value?.[0] === ALL_SELECT_OPTION.value ? undefined : value
      )
    );
    window.open(
      `${
        BFF_HOST[process.env.NODE_ENV] || window.location.origin
      }/api/dossiers/csv-export?token=${getToken()}&${searchQuery}`,
      '_self'
    );
  };

  return (
    <div className="spo-p-dossiers u-margin-top-md u-margin-bottom-md">
      <div className="spo-p-dossiers__content">
        <h3 className="u-padding u-bg-white">{title}</h3>
        <div className="spo-p-dossiers__content-table-wrapper u-bg-white u-padding">
          <AdvancedSearch className="u-margin-bottom-lg" {...advancedSearch} />
          <DossiersTable canExportCsv={permissionsService.canExportDossiersCsv(user)} onExportCsv={handleCsvExport} />
        </div>
      </div>
    </div>
  );
};

export default Dossiers;
